import type { Article } from "./types";

export const workCareerArticles: Article[] = [];
